import LoginPage from '../views/login'
import VerificationPage from '../views/verification'
import type { Route } from './routes'

export const AUTH_ROUTES: Route[] = [
  {
    name: 'Login',
    path: '/',
    component: LoginPage
  },
  {
    name: 'Verify',
    path: '/verify',
    component: VerificationPage
  }
]
